import { render, staticRenderFns } from "./OptionButton.vue?vue&type=template&id=dc74b7d8&scoped=true"
import script from "./OptionButton.vue?vue&type=script&lang=js"
export * from "./OptionButton.vue?vue&type=script&lang=js"
import style0 from "./OptionButton.vue?vue&type=style&index=0&id=dc74b7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc74b7d8",
  null
  
)

export default component.exports